import { render, staticRenderFns } from "./ModalControlsPanel.vue?vue&type=template&id=48636345&"
import script from "./ModalControlsPanel.vue?vue&type=script&lang=ts&"
export * from "./ModalControlsPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports